import React, {useState, useEffect} from 'react';
import { Link } from 'react-router-dom';


export default ({Linkto, Icon,  Titulo,  Notificacao, NotiEstilo,  ValorNoti}) => {
 const [Ver, setVer] = useState("")
 
  function checkDevice() { 
    if( navigator.userAgent.match(/Android/i)
    || navigator.userAgent.match(/webOS/i)
    || navigator.userAgent.match(/iPhone/i)
    || navigator.userAgent.match(/iPad/i)
    || navigator.userAgent.match(/iPod/i)
    || navigator.userAgent.match(/BlackBerry/i)
    || navigator.userAgent.match(/Windows Phone/i)
    ){
       return "pushmenu"; // está utilizando celular
     }
    else {
       return "null"; // não é celular
     }
   }
   


        return (
                
            <li className="nav-item">
            <Link to={Linkto}  className="nav-link"  data-widget={checkDevice()}>
              <i className={Icon} />
              <p style={{marginLeft:10}}>
                {Titulo}
                {Notificacao === true &&
                 <span className="right badge badge-danger">{ValorNoti}</span>
                }
                
              </p>
            </Link>
          </li>
 
        );
    }